import { GPTGameLauncher } from 'src/EXPERIMENTAL_LIB/gpt/games';
import { SampleGptButton } from '../SampleGptButton';
import { useModalContext } from 'src/hooks/useModalContext';
import { isShowEvent } from 'src/config/event/utils';
import { DailyBonusEventIcon } from 'src/config/assets/gptEventIcons/DailyBonusEventIcon';

export const DailyBonusButton = () => {
  const { openModal } = useModalContext();

  const handleRegistration = () => {
    openModal('SIGNUP', { props: { hideWhyNot: true } });
  };

  return (
    <GPTGameLauncher
      gameName="dailyBonus"
      renderButton={({ Icon, ...props }) => (
        <SampleGptButton Icon={isShowEvent('GPT_GAMES') ? DailyBonusEventIcon : Icon} {...props} />
      )}
      openRegistration={handleRegistration}
    />
  );
};
